import React from 'react';
import { withTranslation } from 'react-i18next';
import InfoBar from './InfoBar';

function PrinterV2InfoBar({ printer, status, t }) {
  return (
    <>
      { (!printer || printer.enabled || printer.isServiced || (status === 'print_requested' && printer.status === 'err_job_timeout')) ||
      <InfoBar
        caption={t('printerNotAvailable')}
        type="error"
        number={<a style={{color: "white"}} href="tel:+48530657000">48 530657000.</a>} />
      }
      { printer && printer.isServiced &&
      <InfoBar
        caption={t('printerServiced')}
        type="error" />
      }
    </>
  );
}

export default withTranslation()(PrinterV2InfoBar);
